//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { List } from "@/models";
import WorkItem from "@/components/WorkItem.vue";

export default {
  name: "List",
  created() {
    let id = this.$route.params.id;

    if (!id) {
      return;
    }

    this.listId = id;

    List.getByIdWithUser(id).then(list => {
      this.list = list;

      this.$initWechat().then(() => {
        this.$initWechatShare({
          title: list.get("name") + " ·诗单 · 西窗烛",
          link: location.href,
          image: "http://ac-9pq709je.clouddn.com/bda4f64984c2dba80105.png",
          desc: "品味中国诗词之美"
        });
      });
    });

    this.getWorks();
  },
  scrollBottom() {
    this.getWorks(this.page + 1);
  },
  props: [],
  metaInfo() {
    return {
      title: "诗单"
    };
  },
  data() {
    return {
      listId: null,
      list: null,
      listWorks: [],
      loading: false,
      page: 1
    };
  },
  methods: {
    getWorks: function(page = 1) {
      if (this.loading) {
        return;
      }

      this.loading = true;

      List.getWorks(this.listId, page)
        .then(listWorks => {
          if (page == 1) {
            this.listWorks = listWorks;
          } else {
            this.listWorks = this.listWorks.concat(listWorks);
          }

          this.loading = false;
          this.page = page;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  components: {
    WorkItem
  }
};



// WEBPACK FOOTER //
// ./src/pages/List.vue